import { Component, inject, signal } from '@angular/core';
import { ButtonComponent, IconComponent } from '@shared/components';
import { FormTextComponent } from '@shared/forms';
import { ScannerFacade } from '@app/store/scanner';

@Component({
    selector: 'app-scan-emulator',
    templateUrl: './scan-emulator.component.html',
    styleUrls: ['./scan-emulator.component.css'],
    imports: [ButtonComponent, FormTextComponent, IconComponent],
})
export class ScanEmulatorComponent {
    private readonly scannerFacade = inject(ScannerFacade);

    protected readonly open = signal(false);
    protected readonly code = signal('');

    protected submit(event: Event): void {
        event.preventDefault();

        const code = this.code().trim();

        if (code) {
            this.scannerFacade.emulateScan(code);
            this.code.set('');
        }
    }
}
